import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(getDataURLKeys),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(guardarPizarraLibro);

import { select, call } from 'redux-saga/effects';
import * as Util from '../../util';
import { getPantallaProps // getId,
// getNumPagina,
// getNumPaginaIzquierda,
// getModo    
} from '../../selectors';
import { getNumPaginaIzquierda, getPaginasPorPantalla } from '../../selectors/config-libro'; // import { getConfigLibro } from '../../../selectors/config-libro'

import { getDataURL } from '../../pizarra/selectors';
import { PANTALLA_LIBRO_ID } from '../../constantes'; // import {
//     activarEditor,
//     desactivarEditor
// } from '../../../pizarra/actions'

function getDataURLKeys() {
  var pantallaProps, libroId, numPagina, paginasPorPantalla, keys, numPaginaIzquierda;
  return _regeneratorRuntime.wrap(function getDataURLKeys$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getPantallaProps, PANTALLA_LIBRO_ID);

        case 2:
          pantallaProps = _context.sent;
          libroId = pantallaProps.libroId, numPagina = pantallaProps.numPagina;
          _context.next = 6;
          return select(getPaginasPorPantalla, libroId);

        case 6:
          paginasPorPantalla = _context.sent;
          keys = [];

          if (!(paginasPorPantalla === 1)) {
            _context.next = 12;
            break;
          }

          keys.push(Util.getKeyImagenUsuarioPantallaLibro(libroId, numPagina));
          _context.next = 17;
          break;

        case 12:
          _context.next = 14;
          return select(getNumPaginaIzquierda, libroId, numPagina);

        case 14:
          numPaginaIzquierda = _context.sent;
          keys.push(Util.getKeyImagenUsuarioPantallaLibro(libroId, numPaginaIzquierda));
          keys.push(Util.getKeyImagenUsuarioPantallaLibro(libroId, numPaginaIzquierda + 1));

        case 17:
          return _context.abrupt('return', keys);

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
} // export function* activarEditorPizarraLibro() {
//     const keys = yield* getDataURLKeys();
//     const dataURL_izquierda = Util.getStorageData(keys[0]);
//     window.console.log("sagas libro.pizarra.pizarra-libro.activarEditorPizarraLibro dataKey: " + keys[0])
//     const dataURL_derecha = Util.getStorageData(keys[1]);    
//     window.console.log("sagas libro.pizarra.pizarra-libro.activarEditorPizarraLibro dataKey: " + keys[1])
//     if (keys.length === 1) {                
//         yield put(activarEditor(dataURL_izquierda));    
//     } else {
//         const img = document.createElement('img');
//         const configLibro = yield select(getConfigLibro);
//         const dimensionesBaja = configLibro.dimensionesBaja;
//         const canvas = document.createElement('canvas');
//         canvas.width = dimensionesBaja.w * 2;
//         canvas.height = dimensionesBaja.h;
//         const ctx = canvas.getContext('2d');
//         if (dataURL_izquierda) {
//             img.src = dataURL_izquierda;
//             ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, img.naturalWidth, img.naturalHeight);
//         }
//         if (dataURL_derecha) {
//             img.src = dataURL_derecha;
//             ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, canvas.width / 2, 0, img.naturalWidth, img.naturalHeight);
//         }
//         yield put(activarEditor(canvas.toDataURL()));
//     }
// }


export function guardarPizarraLibro() {
  var dataURL, keys, img;
  return _regeneratorRuntime.wrap(function guardarPizarraLibro$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getDataURL);

        case 2:
          dataURL = _context2.sent;
          _context2.next = 5;
          return call(getDataURLKeys);

        case 5:
          keys = _context2.sent;

          if (!(dataURL === null)) {
            _context2.next = 10;
            break;
          }

          Util.setStorageData(keys[0], null);
          Util.setStorageData(keys[1], null);
          return _context2.abrupt('return');

        case 10:
          if (keys.length === 1) {
            Util.setStorageData(keys[0], dataURL);
          } else {
            // const img = document.createElement('img')
            img = new Image();
            img.addEventListener('load', function () {
              var canvas = document.createElement('canvas');
              canvas.width = Math.floor(img.naturalWidth / 2);
              canvas.height = img.naturalHeight;
              var width = canvas.width,
                  height = canvas.height;
              var ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, width, height);
              ctx.drawImage(img, 0, 0, width, height, 0, 0, width, height);
              Util.setStorageData(keys[0], canvas.toDataURL());
              ctx.clearRect(0, 0, width, height);
              ctx.drawImage(img, width, 0, width, height, 0, 0, width, height);
              Util.setStorageData(keys[1], canvas.toDataURL());
            });
            img.src = dataURL;
          }

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
} // export function* borrarPizarraLibro() {
//     const keys = yield getDataURLKeys()
//     keys.forEach( key => Util.removeStorageData(key))
// }
// export function* desactivarEditorPizarraLibro() {    
//     yield* guardarPizarraLibro()
//     yield put(desactivarEditor())
// }